import { db } from './../../config/Fire';
import * as Constants from './../../constants/nodes_database';

export const SET_PROMOTIONS = 'SET_PROMOTIONS';

const setPromotions = payload => ({ type: SET_PROMOTIONS, payload });

export const setPromotionsToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.PROMOTIONS}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var promosSnap = snapshot.val();
                    var promotions = promosSnap;
                    dispatch(setPromotions(promotions));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setPromotions({}));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setPromotions({}));
        });
    };
};